/**
 * Which account the widget currently holds a verified session for. Kept on the
 * body next to the widget's visibility classes, for the same reason: the widget
 * is init'd once per page load and outlives the React tree that booted it, so a
 * ref would forget who was chatting and the next login in the same tab would
 * inherit their conversation — the bug verification exists to close
 * (GOTU-5243 / GOTU-5918). Its lifetime matches the widget's: both are torn down
 * only when the document is.
 */
const VERIFIED_FOR_KEY = 'saltclickVerifiedFor';

export const getSaltclickVerifiedForUserId = (): string | undefined =>
  document.body.dataset[VERIFIED_FOR_KEY];

export const setSaltclickVerifiedForUserId = (userId?: string): void => {
  if (userId) {
    document.body.dataset[VERIFIED_FOR_KEY] = userId;

    return;
  }
  delete document.body.dataset[VERIFIED_FOR_KEY];
};

/**
 * Ends the verified chat session and closes the conversation with it.
 *
 * Called on logout, where nothing else takes the conversation down: the widget
 * outlives the React tree, so after logout the tab still holds an open chat
 * verified as the account that just left. Waiting until the next login to clear
 * it is not enough — that only fires for a *different* account, so the same user
 * logging back in would reopen the previous conversation. GOTU-5918.
 *
 * Safe when there is nothing to end: `userVerificationAPI` exists only on a
 * deployment with User Verification enabled, and never rejects the caller —
 * logout must not fail because Salesforce did.
 */
export const endSaltclickChatSession = async (): Promise<void> => {
  setSaltclickVerifiedForUserId(undefined);

  try {
    await window.embeddedservice_bootstrap?.userVerificationAPI?.clearSession(true);
  } catch (err) {
    console.error('[Saltclick] Could not end the chat session: ', err);
  }
};
